export default __webpack_public_path__ + "static/media/3152dacf-2e19-467d-8c1e-fe7ad279ba3d.50e0809d.JPG";